export default "__VITE_ASSET__BXQHmGP7__"